"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapPathSchema = exports.PathRelationshipSchema = exports.PathTokenSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
exports.PathTokenSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    address: zod_1.z.string(),
});
exports.PathRelationshipSchema = zod_1.z.object({
    pair: zod_1.z.string(),
    pairAddress: zod_1.z.string(),
    provider: zod_1.z.string(),
    providerFactory: zod_1.z.string(),
});
exports.SwapPathSchema = zod_1.z.object({
    amountIN: core_contracts_ifaces_1.TokenAmountSchema,
    amountOUT: core_contracts_ifaces_1.TokenAmountSchema,
    tokenIN: zod_1.z.string({ required_error: 'tokenIN is required' }),
    tokenOUT: zod_1.z.string({ required_error: 'tokenOUT is required' }),
    pathTokens: zod_1.z.array(exports.PathTokenSchema),
    pathRelationships: zod_1.z.array(exports.PathRelationshipSchema),
});
